import { PayloadAction } from "@reduxjs/toolkit";
import { removeItemFromCollection } from "./remove-item-from-collection";

export function removeActivityHistoryItemReducer(
  state,
  action: PayloadAction<{ id: string; itemId: string }>,
) {
  const { id, itemId } = action.payload;
  state.collections = removeItemFromCollection(state.collections, id, itemId);
}
